// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"collapse_contentContainer__PP9bR","contentOpen":"collapse_contentOpen__5Ppg_","contentClose":"collapse_contentClose__BSh0X"};